<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaReserva />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaReserva from "../Components/Listagens/ListaReserva.vue";
export default {
  name: "ListReserve",
  components: {
    ListaReserva,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>